import { render, staticRenderFns } from "./TeamMemberDocumentsReport.vue?vue&type=template&id=4039a4d1&scoped=true&"
import script from "./TeamMemberDocumentsReport.vue?vue&type=script&lang=js&"
export * from "./TeamMemberDocumentsReport.vue?vue&type=script&lang=js&"
import style0 from "./TeamMemberDocumentsReport.vue?vue&type=style&index=0&id=4039a4d1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4039a4d1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4039a4d1')) {
      api.createRecord('4039a4d1', component.options)
    } else {
      api.reload('4039a4d1', component.options)
    }
    module.hot.accept("./TeamMemberDocumentsReport.vue?vue&type=template&id=4039a4d1&scoped=true&", function () {
      api.rerender('4039a4d1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Reports/TeamMemberDocumentsReport.vue"
export default component.exports